
export const convertHmsInSeconds = (hms) => {
    const getSeconds = hms.split(':').reduce((acc, time) => (60 * acc) + +time)

    return getSeconds
}

